/** The share of a progress bar's track that is always filled, so the first
 * step reads as started rather than empty. */
export const MIN_PROGRESS_FILL_PERCENT = 5;

/** The width a progress bar draws for `percentage` (0-100): never below the
 * minimum fill, still exactly 100 at the end. */
export function progressFillPercent(percentage: number): number {
  const clamped = Math.max(0, Math.min(100, percentage));
  return (
    MIN_PROGRESS_FILL_PERCENT +
    (clamped * (100 - MIN_PROGRESS_FILL_PERCENT)) / 100
  );
}
